import loadImage from 'blueimp-load-image';

const defaultOptions = {
  orientation: true,
};

export default (image, options = {}) => new Promise((resolve, reject) => {
  loadImage(image, (data) => {
    if (data.type === 'error') {
      reject(data);
    } else {
      resolve(data);
    }
  }, {
    ...defaultOptions,
    ...options,
  });
});



// WEBPACK FOOTER //
// ./src/Utils/Images/load.js